<template>
  <div class="container">
    <loading v-show="isShowLoading"></loading>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import Loading from '@/components/Loading.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    Loading,
  },
  computed: {
    ...mapGetters(['isShowLoading']),
  },
}
</script>
